import { Action } from '@ngrx/store';

import { Utente } from 'src/app/shared/models/utente.model';
import { Resource } from 'src/app/shared/models/resource.model';
import { orderByModel } from 'src/app/shared/models/filter-data/order-by.model';
import { SingleFilter } from 'src/app/shared/models/filter-data/single-filter.model';
import { OperatorFilter } from 'src/app/shared/models/filter-data/operator-filter.model';
import { FilterDataUserResponse } from '../utenti.service';

/**Descrizione per il tipo SortTabella */
export const SORT_TABELLA = '[UTENTI] Sort Tabella';
/**Descrizione per il tipo FilterTabella */
export const FILTER_TABELLA = '[UTENTI] Filter Tabella';

/**Descrizione per il tipo StartGetUserList */
export const START_GET_USER_LIST = '[UTENTI] Inizio recupero lista utenti';
/**Descrizione per il tipo GetUserListSuccess */
export const GET_USER_LIST_SUCCESS = '[UTENTI] Recupero lista utenti avvenuto con successo';
/**Descrizione per il tipo GetUserListFailure */
export const GET_USER_LIST_FAILURE = '[UTENTI] Errore in recupero lista utenti';

/**Descrizione per il tipo StartCreateUser */
export const START_CREATE_USER = '[UTENTI] Inizio creazione di un nuovo utente';
/**Descrizione per il tipo CreateUserSuccess */
export const CREATE_USER_SUCCESS = '[UTENTI] Creazione di un nuovo utente avvenuta con successo';
/**Descrizione per il tipo CreateUserFailure */
export const CREATE_USER_FAILURE = '[UTENTI] Mancata creazione di un nuovo utente';

/**Descrizione per il tipo StartRemoveUser */
export const START_REMOVE_USER = '[UTENTI] Inizio rimozione utente';
/**Descrizione per il tipo RemoveUserSuccess */
export const REMOVE_USER_SUCCESS = '[UTENTI] Avvenuta rimozione utente';
/**Descrizione per il tipo RemoveUserFailure */
export const REMOVE_USER_FAILURE = '[UTENTI] Mancata rimozione utente';

/**Descrizione per il tipo StartUpdateUser */
export const START_UPDATE_V2_USER = '[UTENTI] V2 Inizio modifica utente';
/**Descrizione per il tipo UpdateUserSuccess */
export const UPDATE_USER_V2_SUCCESS = '[UTENTI] V2 Modifica utente avvenuta con successo';
/**Descrizione per il tipo UpdateUserFailure */
export const UPDATE_USER_V2_FAILURE = '[UTENTI] V2 Mancata modifica utente';


/**Descrizione per il tipo StartGetResources */
export const START_GET_RESOURCES = '[UTENTI] Inizio recupero risorse associate a un utente';
/**Descrizione per il tipo GetResourcesSuccess */
export const GET_RESOURCES_SUCCESS = '[UTENTI] Recupero risorse utente avvenuto con successo';
/**Descrizione per il tipo GetResourcesFailure */
export const GET_RESOURCES_FAILURE = '[UTENTI] Mancato recupero delle risorse utente'

/**Descrizione per il tipo StartGetResources */
export const START_GET_TRACTATES = '[UTENTI] Inizio recupero elenco trattati';
/**Descrizione per il tipo GetResourcesSuccess */
export const GET_TRACTATES_SUCCESS = '[UTENTI] Recupero elenco trattati avvenuto con successo';
/**Descrizione per il tipo GetResourcesFailure */
export const GET_TRACTATES_FAILURE = '[UTENTI] Mancato recupero elenco trattati';

/**Descrizione per il tipo StartGetResources */
export const START_GET_SUB_RESOURCES = '[UTENTI] Inizio recupero elenco sottorisorse';
/**Descrizione per il tipo GetResourcesSuccess */
export const GET_SUB_RESOURCES_SUCCESS = '[UTENTI] Recupero elenco sottorisorse avvenuto con successo';
/**Descrizione per il tipo GetResourcesFailure */
export const GET_SUB_RESOURCES_FAILURE = '[UTENTI] Mancato recupero elenco sottorisorse';

/**Descrizione per il tipo StartAddUserResource */
export const START_ADD_USER_RESOURCE = '[UTENTI] Inizio assegnazione risorsa a utente';
/**Descrizione per il tipo AddUserResourceSuccess */
export const ADD_USER_RESOURCE_SUCCESS = '[UTENTI] Assegnazione risorsa avvenuto con successo';
/**Descrizione per il tipo AddUserResourceFailure */
export const ADD_USER_RESOURCE_FAILURE = '[UTENTI] Mancata assegnazione risorsa';

/**Descrizione per il tipo SelectUser */
export const SELECT_USER = '[UTENTI] Selezione di un utente';

/**Descrizione per il tipo StartRemoveUserResource */
export const START_REMOVE_USER_RESOURCE = '[UTENTI] Inizio rimozione risorsa assegnata';
/**Descrizione per il tipo RemoveUserResourceSuccess */
export const REMOVE_USER_RESOURCE_SUCCESS = '[UTENTI] Rimozione risorsa assegnata avvenuto con successo';
/**Descrizione per il tipo RemoveUserResourceFailure */
export const REMOVE_USER_RESOURCE_FAILURE = '[UTENTI] Mancata rimozione risorsa assegnata';

export const START_RESTORE_USER = '[UTENTI] Inizio ripristino utenza cancellata';
export const RESTORE_USER_SUCCESS = '[UTENTI] Ripristino utenza avvenuto con successo';
export const RESTORE_USER_FAILURE = '[UTENTI] Mancato ripristino utenza';

/**Descrizione per il tipo CleanUtentiOnDestroy */
export const CLEAN_UTENTI_ON_DESTROY = '[UTENTI] Svuotamento dello stato relativo in uscita dal componente';

export const CHANGE_DISPLAY_ADD = '[UTENTI] Cambia lo stato di visualizzazione di aggiungi utente';

/**Azione di ordinamento della tabella sulla base di una colonna */
export class SortTabella implements Action {
    readonly type = SORT_TABELLA;

    /**
     * Costruttore dell'azione SortTabella
     * @param payload {object} ordCresc boolean (se l'ordinamento è crescente), fieldName string (nome del campo sul quale basare l'ordinamento)
     */
    constructor(public payload: orderByModel[]) { }
}

/**Azione di filtro della tabella sulla base del valore di una proprietà */
export class FilterTabella implements Action {
    readonly type = FILTER_TABELLA;

    /**
     * Costruttore dell'azione FilterTabella
     * @param payload {object} filtro string (nome della proprietà sulla quale filtro), valoreFiltro (valore inserito nel filtro)
     */
    constructor(public payload: (SingleFilter | OperatorFilter)) { }
}

/**Azione di inizio recupero lista utenti */
export class StartGetUserList implements Action {
    readonly type = START_GET_USER_LIST;
}

/**Azione di avvenuto recupero lista utenti */
export class GetUserListSuccess implements Action {
    readonly type = GET_USER_LIST_SUCCESS;

    /**
     * Costruttore per l'azione di avvenuto recupero lista utenti
     * @param payload {Utente[]} elenco di utenti recuperato da BE
     */
    constructor(public payload: FilterDataUserResponse) { }
}

/**Azione di errore nel recupero lista utenti */
export class GetUserListFailure implements Action {
    readonly type = GET_USER_LIST_FAILURE;

    constructor(public payload: any) { }
}

/**Azione iniziale per la creazione di un nuovo utente */
export class StartCreateUser implements Action {
    readonly type = START_CREATE_USER;

    constructor(public payload: Utente,
        public isUndoRedoOperation: boolean = false) { }
}

/**Azione di avvenuta creazione di un nuovo utente */
export class CreateUserSuccess implements Action {
    readonly type = CREATE_USER_SUCCESS;

    /**
     * Costruttore per l'azione CreateUserSuccess
     * @param payload {Utente} il nuovo utente restituito da BE (che deve fornirci l'ID)
     */
    constructor(public payload: Utente,
        public isUndoRedoOperation: boolean = false) { }
}

/**Azione di mancata creazione di un nuovo utente */
export class CreateUserFailure implements Action {
    readonly type = CREATE_USER_FAILURE;

    constructor(public payload: any) { }
}

export class StartRestoreUser implements Action {
    readonly type = START_RESTORE_USER;

    constructor(public payload: number) { }
}

export class RestoreUserSuccess implements Action {
    readonly type = RESTORE_USER_SUCCESS;
}

export class RestoreUserFailure implements Action {
    readonly type = RESTORE_USER_FAILURE;
}

/**Azione di inizio rimozione utente */
export class StartRemoveUser implements Action {
    readonly type = START_REMOVE_USER;

    /**
     * Costruttore per l'azione di StartRemoveUser
     * @param payload {number} identificativo dell'utente da rimuovere
     */
    constructor(public payload: number,
        public isUndoRedoOperation: boolean = false) { }
}

/**Azione di avvenuta rimozione utente */
export class RemoveUserSuccess implements Action {
    readonly type = REMOVE_USER_SUCCESS;

    /**
     * Costruttore dell'azione RemoveUserSuccess
     * @param payload {number} identificativo dell'utente rimosso
     */
    constructor(public payload: number,
        public isUndoRedoOperation: boolean = false) { }
}

/**Azione di mancata rimozione utente */
export class RemoveUserFailure implements Action {
    readonly type = REMOVE_USER_FAILURE;

    constructor(public payload: any) { }
}

/**Azione di inizio modifica utente */
export class StartUpdateUserV2 implements Action {
    readonly type = START_UPDATE_V2_USER;

    /**
     * Costruttore per l'azione di inizio modifica utente
     * @param payload {object} idUser number id dell'utente modificato, nomeCampo string etichetta della proprietà modificata, newValue any il nuovo valore inserito
     */
    constructor(public payload: { idUser: number, nomeCampo: string, newValue: any },
        public isUndoRedoOperation: boolean = false) { }
}

/**Azione di avvenuta modifica utente */
export class UpdateUserV2Success implements Action {
    readonly type = UPDATE_USER_V2_SUCCESS;

    /**
     * Costruttore per l'azione di avvenuta modifica utente
     * @param payload {Utente} utente aggiornato
     */
    constructor(public payload: { nuovoUtente: Utente, campoMod: string },
        public isUndoRedoOperation: boolean = false) { }
}

/**Azione di mancata modifica utente */
export class UpdateUserV2Failure implements Action {
    readonly type = UPDATE_USER_V2_FAILURE;

    constructor(public payload: any) { }
}


/**Azione di inizio recupero delle risorse utente */
export class StartGetResources implements Action {
    readonly type = START_GET_RESOURCES;

    /**
     * Costruttore per l'inizio recupero risorse utente
     * @param paylaod {number} id dell'utente del quale si vogliono recuperare le risorse
     */
    constructor(public paylaod: number) { }
}

/**Azione di avvenuto recupero risorse utente */
export class GetResourcesSuccess implements Action {
    readonly type = GET_RESOURCES_SUCCESS;

    /**
     * Costruttore per l'avvenuto recupero di risorse utente
     * @param payload {Resource[]} l'array di risorse associate all'utente
     */
    constructor(public payload: Resource[]) { }
}

/**Azione di mancato recupero risorse utente */
export class GetResourcesFailure implements Action {
    readonly type = GET_RESOURCES_FAILURE;

    constructor(public payload: any) { }
}

/**Azione di inizio recupero elenco trattati */
export class StartGetTractates implements Action {
    readonly type = START_GET_TRACTATES;
}

/**Azione di avvenuto recupero elenco trattati */
export class GetTractatesSuccess implements Action {
    readonly type = GET_TRACTATES_SUCCESS;

    /**
     * Costruttore per l'avvenuto recupero elenco trattati
     * @param payload {Resource[]} elenco trattati
     */
    constructor(public payload: Resource[]) { }
}

/**Azione di mancato recupero elenco trattati */
export class GetTractatesFailure implements Action {
    readonly type = GET_TRACTATES_FAILURE;

    constructor(public payload: any) { }
}

/**Azione di inizio recupero elenco sottorisorse */
export class StartGetSubResources implements Action {
    readonly type = START_GET_SUB_RESOURCES;

    constructor(public payload: number) { }
}

/**Azione di avvenuto recupero elenco sottorisorse */
export class GetSubResourcesSuccess implements Action {
    readonly type = GET_SUB_RESOURCES_SUCCESS;

    /**
     * Costruttore per l'avvenuto recupero elenco sottorisorse
     * @param payload {Resource[]} elenco sottorisorse
     */
    constructor(public payload: Resource[]) { }
}

/**Azione di mancato recupero elenco trattati */
export class GetSubResourcesFailure implements Action {
    readonly type = GET_SUB_RESOURCES_FAILURE;

    constructor(public payload: any) { }
}

/**Azione di inizio aggiunta risorsa assegnata a un utente */
export class StartAddUserResource implements Action {
    readonly type = START_ADD_USER_RESOURCE;

    /**
     * Costruttore per l'azione di inizio assegnazione risorsa
     * @param payload {object} number id dell'utente, Resource risorsa assegnata
     */
    constructor(public payload: { userId: number, resource: Resource }) { }
}

/**Azione di avvenuta assegnazione risorsa a utente */
export class AddUserResourceSuccess implements Action {
    readonly type = ADD_USER_RESOURCE_SUCCESS;

    /**
     * Costruttore per l'azione di assegnazione risorsa a utente
     * @param payload {Resource} risorsa assegnata all'utente
     */
    constructor(public payload: Resource) { }
}

/**Azione di mancata assegnazione risorsa a utente */
export class AddUserResourceFailure implements Action {
    readonly type = ADD_USER_RESOURCE_FAILURE;

    constructor(public payload: any) { }
}

/**Azione di selezione utente */
export class SelectUser implements Action {
    readonly type = SELECT_USER;

    /**
     * Costruttore dell'azione di selezione utente
     * @param payload {Utente} utente selezionato
     */
    constructor(public payload: Utente) { }
}

/**Azione di inizio rimozione risorsa assegnata */
export class StartRemoveUserResource implements Action {
    readonly type = START_REMOVE_USER_RESOURCE;

    /**
     * Costruttore dell'azione di inizio rimozione della risorsa assegnata
     * @param payload {object} number id dell'utente, number id della risorsa
     */
    constructor(public payload: { userId: number, resourceId: number }) { }
}

/**Azione di avvenuta rimozione risorsa assegnata */
export class RemoveUserResourceSuccess implements Action {
    readonly type = REMOVE_USER_RESOURCE_SUCCESS;

    /**
     * Costruttore dell'azione di avvenuta rimozione risorsa assegnata
     * @param payload {number} id della risorsa rimossa
     */
    constructor(public payload: number) { }
}

/**Azione di mancata rimozione della risorsa assegnata */
export class RemoveUserResourceFailure implements Action {
    readonly type = REMOVE_USER_RESOURCE_FAILURE;

    constructor(public payload: any) { }
}

export class ChangeDisplayAdd implements Action {
    readonly type = CHANGE_DISPLAY_ADD;

    constructor(public payload: boolean) { }
}

/**Azione di svuotamento dello stato utenti in distruzione del componente */
export class CleanUtentiOnDestroy implements Action {
    readonly type = CLEAN_UTENTI_ON_DESTROY;
}

/**Azioni esportate per lo store di Utenti */
export type UtentiAction =
    | SortTabella
    | FilterTabella
    | StartGetUserList
    | GetUserListSuccess
    | GetUserListFailure
    | StartCreateUser
    | CreateUserSuccess
    | CreateUserFailure
    | StartRemoveUser
    | RemoveUserSuccess
    | RemoveUserFailure
    | StartUpdateUserV2
    | UpdateUserV2Success
    | UpdateUserV2Failure
    | StartGetResources
    | GetResourcesSuccess
    | GetResourcesFailure
    | StartGetTractates
    | GetTractatesSuccess
    | GetTractatesFailure
    | StartGetSubResources
    | GetSubResourcesSuccess
    | GetSubResourcesFailure
    | StartAddUserResource
    | AddUserResourceSuccess
    | AddUserResourceFailure
    | SelectUser
    | StartRemoveUserResource
    | RemoveUserResourceSuccess
    | RemoveUserResourceFailure
    | ChangeDisplayAdd
    | CleanUtentiOnDestroy
    | StartRestoreUser
    | RestoreUserSuccess
    | RestoreUserFailure;